import { RouteHandler } from 'wee-routes';
import { _win } from 'core/variables';
import $ from 'wee-dom';
import $events from 'wee-events';

class Progress {
    constructor() {
        this.$win = $(_win);
        /**
         * Full progress bar
         * @member {$}
         */
        this.$progress = $(':progress');

        /**
         * Current progress
         * @member {$}
         */
        this.$bar = $(':progressBar');

        /**
         * Scroll state
         * @member {boolean}
         */
        this.scrolled = false;

        /**
         * Height of everything above the progress bar
         * Set data-ref="progressTop" on each element to include
         * @member {$}
         */
        this.topHeight = 0;

        /**
         * Height of the hero image if it exists
         * @member {int|null}
         */
        this.heroHeight = null;

        /**
         * Height of the element of which to measure progress
         * @member {int|null}
         */
        this.elementHeight = null;

        /**
         * Percentage of the measureable element that you've scrolled
         * @member {int|null}
         */
        this.scrollHeight = null;
    }

    /**
     * Calculate heights of necessary elements
     */
    getHeights() {
        this.heroHeight = $(':hero').length ? $(':hero').height() : 0;
        this.elementHeight = $(':progressHeight').height() + this.heroHeight;

        $(':progressTop').each((el) => {
            this.topHeight = this.topHeight + $(el).height();
        });
    }

    /**
     * Measure scrolled distance and set width of progress bar
     */
    scrolling(win) {
        const windowTop = $(win).scrollTop();
        const elementHeight = this.elementHeight - ($(win).height() - 200);

        this.scrollHeight = ((windowTop - this.topHeight) / elementHeight) * 100;

        this.$bar.width(this.scrollHeight + '%');
    }

    /**
     * Stick the progress bar to the top of the page
     */
    sticky(win) {
        if (this.$win.scrollTop() > this.topHeight && ! this.scrolled) {
            this.$progress.css('position', 'fixed');
            this.scrolled = true;
        } else if ($(win).scrollTop() < this.topHeight) {
            this.$progress.css('position', 'static');
            this.scrolled = false;
            this.$bar.width(0);
        }
    }
}

export default new RouteHandler({
    init() {
        const progress = new Progress();

        progress.getHeights();

        $events.on({
            window: {
                scroll(e, el) {
                    progress.scrolling(el);
                    progress.sticky(el);
                },
                resize() {
                    progress.getHeights();
                },
            },
        });
    },
});
